// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N7Dbx","delete":"styles_delete__fY91U","update":"styles_update__2SZPT","add":"styles_add__32ww-"};